import { FormattedMessage } from "react-intl";
import { Heading, Skeleton } from "@lendcord/concord";
import { ProfileField } from "@/features/profile/components/ProfileField";

// Mirrors ApplicationDetailView's real section layout (heading/badge row,
// bordered sections with the same grid shapes) with every value swapped for
// ProfileField's skeleton — loan details is omitted since it's conditional on
// applicationType, unknown until loaded.
export function ApplicationDetailViewSkeleton() {
  return (
    <div>
      <div className="flex items-center gap-3">
        <Heading level={2}>
          <FormattedMessage id="lender.onboarding.viewPageTitle" />
        </Heading>
        <Skeleton variant="rect" className="h-5 w-16" />
      </div>
      <Skeleton variant="text" className="mt-1.5 h-4 w-40" />

      <div className="mt-6 rounded-md border border-border bg-surface-raised">
        <section className="px-6 py-3">
          <Heading level={4} className="text-accent-600">
            <FormattedMessage id="lender.onboarding.applicationTypeHeading" />
          </Heading>
          <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-3">
            <ProfileField labelId="lender.onboarding.columnFullName" value="" loading />
            <ProfileField labelId="lender.onboarding.columnApplicationType" value="" loading />
            <ProfileField labelId="lender.onboarding.columnReadableId" value="" loading />
          </div>
        </section>

        <section className="px-6 py-3">
          <Heading level={4} className="text-accent-600">
            <FormattedMessage id="lender.onboarding.locationHeading" />
          </Heading>
          <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-3">
            <div className="sm:col-span-3">
              <ProfileField labelId="lender.onboarding.columnLocation" value="" loading />
            </div>
            <ProfileField labelId="lender.onboarding.latitudeLabel" value="" loading />
            <ProfileField labelId="lender.onboarding.longitudeLabel" value="" loading />
          </div>
        </section>

        <section className="px-6 py-3">
          <Heading level={4} className="text-accent-600">
            <FormattedMessage id="lender.onboarding.additionalDetailsHeading" />
          </Heading>
          <div className="mt-4 grid grid-cols-1 gap-6 sm:grid-cols-3">
            <ProfileField labelId="lender.onboarding.centerNameLabel" value="" loading />
            <ProfileField labelId="lender.onboarding.areaLabel" value="" loading />
            <div className="sm:col-span-3">
              <ProfileField labelId="lender.onboarding.columnRemarks" value="" loading />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
